import React from 'react';
import IconButton from '@mui/material/IconButton';
import OptionsIcon from '@mui/icons-material/TuneRounded';
import Button from '@mui/material/Button';
import ModalDialog from '../../UI/Dialog/ModalDialog';
import Switch from '../../UI/Switch/Switch';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import { useTranslation } from 'react-i18next';

export default function OptionsButton(props) {
    const { onChange, options, toggleDialog, open } = props;
    const { t } = useTranslation();
    const buttonStack = () => {
        return (
            <Button variant="text" color="secondary" onClick={toggleDialog}>
                {t('close')}
            </Button>
        )
    }
    if(open){
        return (
            <ModalDialog buttonStack={buttonStack()} title={t('options')} toggleDialog={() => toggleDialog()}
                        dialogStatus={open} fullWidth maxWidth='xs'>
                <FormGroup>
                {options != null && Object.entries(options).map(([key, value]) => {
                    return ( 
                        <FormControlLabel key={key} control={<Switch key={key} checked={value} onChange={onChange} name={key} />} label={`${t('print')} ${t(key)}`} />
                        )
                    })}                    
                </FormGroup>
            </ModalDialog>
        )
    }else {
        return (
            <IconButton aria-label="options" onClick={toggleDialog} sx={{ color: '#38546D' }}>
                <OptionsIcon />
            </IconButton>
        )
    }    
}